import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationEN from 'assets/languageFiles/translationEN.json';
import translationFR from 'assets/languageFiles/translationFR.json';

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en', // default language
        debug: false,
        resources: {
            en: {
                translation: translationEN,
            },
            fr: {
                translation: translationFR,
            },
        },
    });
